export default __webpack_public_path__ + "static/media/Vigo.e92f3b77.jpg";